import React, { useState } from "react";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import JoditEditor from "jodit-react";
import Select from "react-select";
import { Input } from "../../../_metronic/_partials/controls";

const options = [
  { value: 'monthly', label: 'Monthly' },
  { value: 'annually', label: 'Annually' },
];

const Schema = Yup.object().shape({
  plan_name: Yup.string()
    .min(2, "Minimum 2 characters allow")
    .max(50, "Maximum 50 characters allow")
    .required("Plan Name is required")
    .matches(/^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$/, 'Plan Name is not valid'),
  plan_price: Yup.number()
    // .min(2, "Minimum 2 symbols")
    // .max(50, "Maximum 10 symbols")
    .max(9999999, "Plan Price should be less then 7 digit")
    .typeError('Plan Price must be a number')
    .required("Plan Price is required")
    .min(1, "Please Enter valid price"),
  plan_type: Yup.string()
    .required("Please select a Plan Type"),
  // plan_desc: Yup.string()
  //   .min(2, "Minimum 2 symbols")
  // .max(250, "Maximum 250 symbols")
  // .required("Plan Description is required"),
  inventory_type: Yup.string()
    .required("Plan Inventory Type is required"),
  plan_inventory: Yup.string()
    .when("inventory_type",
      (val, schema) => {
        if (val === "custom") return Yup.number()
          .required("Plan Inventory is required")
          .typeError('Plan Price must be a number')
          .min(1, "Minimum 1 number")
          .max(999999, "Plan Inventory should be less then 6 digit")
          .integer('Please enter valid Plan Product Inventory')
        else return Yup.string().notRequired().nullable(true);
      })
});


export function WixPriceEditAddForm({ wix, id, btnRef, saveWix }) {
  const editor = React.useRef(null);
  const config = {
    readonly: false, // all options from https://xdsoft.net/jodit/doc/
    askBeforePasteHTML: false,
    askBeforePasteFromWord: false,
  };
  const [content, setContent] = React.useState("");
  const [checkFlag, setCheckFlag] = useState({
    status: true
  });
  const handleStatus = (e, setFieldValue) => {
    let elementValue = e.target.value;
    let elementName = e.target.name;
    setCheckFlag(!checkFlag.status);
    setFieldValue(elementName, elementValue)
  }
  // const showRestricted = id != undefined ? false : true;
  const showRestricted = true;
  const [selectedOption, setSelectedOption] = React.useState(options[0].value);

  return (
    <>
      <Formik
        enableReinitialize={true}
        initialValues={wix}
        validationSchema={Schema}
        onSubmit={async (values, { setErrors }) => {
          await saveWix(values);
        }}
      >
        {({ handleSubmit, field, setFieldValue, values, handleChange, errors }) => (
          <>
            <Form className='form form-label-right'>

              <div className='form-group row mt-5'>
                <Field
                  name="plan_name"
                  component={Input}
                  placeholder='Plan Name'
                  label="Plan Name"
                  valid="true"
                />
              </div>
              {showRestricted &&
                <div>
                  <div className='form-group row mt-5'>
                    <Field
                      name="plan_price"
                      component={Input}
                      placeholder='Plan Price'
                      label="Plan Price"
                      valid="true"
                    />
                  </div>
                  <div className='form-group row mt-5'>
                    <label className="col-xl-3 col-lg-2 col-form-label text-right">Plan Type</label>
                    <div className="col-lg-6 col-xl-6">
                      <Select
                        classNamePrefix='selected plans'
                        options={options}
                        name='plan_type'
                        defaultValue={selectedOption}
                        onChange={async (selectedOption) => {
                          setFieldValue(
                            "plan_type",
                            selectedOption.value
                          );
                        }}
                        value={options?.filter(function (option) {
                          return option.value === values.plan_type;
                        })}
                      />
                    </div>
                  </div>
                  {id ? (
                    <React.Fragment>
                      <div className='form-group row mt-5'>
                        <label className="col-xl-3 col-lg-2 col-form-label text-right">Inventory Type</label>
                        <div className="col-lg-6 col-xl-6">
                          <div className='radio-inline mt-3'>
                            <label className='radio'>
                              <Field
                                type='radio'
                                name='inventory_type'
                                value="unlimited"
                                onChange={(e) => {
                                  console.log(e.target.value)
                                  handleStatus(e, setFieldValue)
                                }}

                              />
                              <span></span>
                              Unlimited
                            </label>
                            <label className='radio'>
                              <Field
                                type='radio'
                                value="custom"
                                name='inventory_type'
                                onChange={(e) => {
                                  handleStatus(e, setFieldValue)
                                }}

                              />
                              <span></span>
                              Custom
                            </label>
                          </div>
                        </div>
                      </div>
                    </React.Fragment>) : (
                    <React.Fragment>
                      <div className='form-group row mt-5'>
                        <label className="col-xl-3 col-lg-2 col-form-label text-right">Inventory Type</label>
                        <div className="col-lg-6 col-xl-6">
                          <div className='radio-inline mt-3'>
                            <label className='radio'>
                              <Field
                                type='radio'
                                name='inventory_type'
                                value="unlimited"
                                onChange={(e) => {
                                  handleStatus(e, setFieldValue)
                                }}
                                checked={values.inventory_type === "unlimited"}
                              // readOnly
                              />
                              <span></span>
                              Unlimited
                            </label>
                            <label className='radio'>
                              <Field
                                type='radio'
                                value="custom"
                                name='inventory_type'
                                onChange={(e) => {
                                  handleStatus(e, setFieldValue)
                                }}
                                checked={values.inventory_type === "custom"}
                              // readOnly

                              />
                              <span></span>
                              Custom
                            </label>
                          </div>
                        </div>
                      </div>
                    </React.Fragment>)}
                  {values.inventory_type === "custom" ?
                    <div className='form-group row mt-5'>
                      <Field
                        name="plan_inventory"
                        component={Input}
                        type="number"
                        placeholder='Plan Product Inventoty'
                        label="Plan Product Inventory"
                        valid="true"
                      />
                    </div> : ""}
                </div>
              }

              <div className='form-group row mt-5'>
                <label className="col-xl-3 col-lg-2 col-form-label text-right">Enter price description</label>
                <div className="col-lg-6 col-xl-6">
                  {id ? (
                    <React.Fragment>
                      <JoditEditor
                        ref={editor}
                        value={wix.plan_desc}
                        config={config}
                        tabIndex={5} // tabIndex of textarea
                        onBlur={(newContent) => setContent(newContent)} // preferred to use only this option to update the content for performance reasons
                        onChange={(newContent) => {
                          setFieldValue("plan_desc", newContent);
                        }}
                      />
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      <JoditEditor
                        ref={editor}
                        value={content}
                        config={config}
                        tabIndex={1} // tabIndex of textarea
                        onBlur={(newContent) => setContent(newContent)} // preferred to use only this option to update the content for performance reasons
                        onChange={(newContent) => {
                          setFieldValue("plan_desc", newContent);
                        }}
                      />
                    </React.Fragment>
                  )}

                </div>
              </div>
              <button
                type='submit'
                style={{ display: "none" }}
                ref={btnRef}
                onSubmit={() => handleSubmit()}>
              </button>

            </Form>
          </>
        )}
      </Formik>
    </>
  );
}
